var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._b({staticClass:"icon",domProps:{"innerHTML":_vm._s(_vm.icon)}},'div',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }